module.exports = __webpack_public_path__ + "static/p5-75aef64d11ee428608b361980991c441.jpg";